import services from 'services/services';

// Import variables
import { TRANSACTION_TYPES } from 'helpers/prices';

// Import helpers
import { INITIAL_PROMOTION } from 'helpers';

// Import api
import {
	GET_SUBSCRIBER_PROMOTIONS_API,
	GET_LAST_GATEWAY_API,
	GET_PAYMENT_AGREEMENTS_API
} from 'helpers/api';

export const INITIAL_STATE = {
	selectedPriceId: '',
	paymentMethods: [],
	productName: '',
	isPaymentValid: false,
	transactionType: '',
	userPromotions: [],
	promotion: INITIAL_PROMOTION
};

export const fetchSubscriberPromotions = () => {
	return services.get(GET_SUBSCRIBER_PROMOTIONS_API);
};

export const fetchLastGateway = () => {
	return services.get(GET_LAST_GATEWAY_API);
};

export const fetchPaymentAgreements = () => {
	return services.get(GET_PAYMENT_AGREEMENTS_API);
};

export const getTransactionType = ({ paymentMethods, selectedPriceId }) => {
	const { RENT, PURCHASE, SUBSCRIPTION } = TRANSACTION_TYPES;

	const { payment_method, period } = paymentMethods.find(
		({ id }) => id === selectedPriceId
	);

	if (payment_method.includes(SUBSCRIPTION)) {
		return SUBSCRIPTION;
	} else if (!period) {
		return PURCHASE;
	}

	return RENT;
};

export const DEFAULT_PAYMENT_METHOD = {
	id: null,
	payment_method: '',
	period: 0,
	period_unit: 'hour',
	price: 0,
	promotions: {},
	since_first_access: false,
	views_limit: null
};
